import { defineStore, acceptHMRUpdate } from "pinia";
import { createTranslationHighlightField } from "../lib/createTranslationHighlightField";

export const useTranslationHighlights = defineStore(
  "translation-content-highlights-field",
  createTranslationHighlightField({
    fieldId: "highlights",
    isRequired: true,
    highlightKey: "highlights",
    customKey: "custom_highlights",
    premadeKey: "premade_highlights",
  })
);

// HMR
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTranslationHighlights, import.meta.hot));
}
